<template>
    <b-modal
            ref="modal"
            size="md"
            title="Wybierz aplikację"
            :visible="true"
            @hidden="$emit('hidden')"
            hide-footer
            no-close-on-esc
            no-close-on-backdrop
    >
        <VueElementLoading :active="waiting"/>

        <FormSlot
            label="Typ aplikacji"
        >
            <BaseSelect
                    v-model="query.type"
                    class="dropdown-select"
                    :options="types"
                    placehoder="Wybierz typ aplikacji"
            >
            </BaseSelect>
        </FormSlot>


        <div v-if="query.type && applications.length > 0">
            <FormSlot label="Szukaj aplikacji">
                <input type="text" v-model="query.q" class="form-control" placeholder="Szukaj aplikacji">
            </FormSlot>
            <div class="d-flex flex-wrap mt-3">
                <ApplicationEntry
                        v-for="application in normalizedApplications"
                        :key="application.uuid"
                        :application="application"
                        :is-disabled="isDisabled(application)"
                        @selectApplication="grantAccess(application)"
                ></ApplicationEntry>
            </div>

            <Pagination
                    v-model="query.page"
                    :total="total"
                    :page-size="query.pageSize"
                    @sizeChange="query.pageSize = $event"
            ></Pagination>
        </div>
        <div v-else-if="!waiting && query.type && applications.length === 0" class="alert alert-info p-2 mt-3">
            Nie znaleziono aplikacji wybranego typu
        </div>


    </b-modal>
</template>

<script>
import {fetchApplications, fetchApplicationTypes} from "@/modules/Applications/repository/ApplicationRepository";
import Pagination from "@/components/Pagination/Pagination.vue";
import {debounce} from "lodash";
import {normalizeApplication} from "@/modules/Applications/service/AppNormalizer";
import ApplicationEntry from "@/modules/Applications/components/ApplicationEntry.vue";
import {BaseSelect, FormSlot} from "@dealer-group/dealerui";
import VueElementLoading from "vue-element-loading";
import {TYPE_UNDEFINED} from "@/modules/Applications/service/applicationsData";
import {grantAccessToApplication} from "@/services/ApplicationService";

export default {
    name: "GrantApplicationModal",
    components: {Pagination, ApplicationEntry, BaseSelect, VueElementLoading, FormSlot},
    props: {
        currentApplications: Array,
    },

    data: () => ({
        query: {
            q: '',
            type: '',
            page: 1,
            pageSize: 30
        },
        total: 0,
        applications: [],
        types: [],
        waiting: false
    }),


    mounted() {
        this.fetchApplicationTypes();
    },

    computed: {
        normalizedApplications() {
            return this.applications.map(application => normalizeApplication(application));
        }
    },
    watch: {
        "query.q": {
            handler: debounce(function () {
                if (!this.query.type) {
                    return;
                }
                this.query.page = 1;
                this.fetchApplications();
            }, 500),
            deep: true

        },

        "query.type": {
            handler() {
                if (!this.query.type) {
                    return;
                }
                this.query.page = 1;
                this.query.q = '';
                this.fetchApplications();
            },
            deep: true

        },
        "query.page": function () {
            this.fetchApplications();
        },
        "query.pageSize": function () {
            this.query.page = 1;
            this.fetchApplications();
        },
    },

    methods: {
        fetchApplications() {
            this.waiting = true;
            return fetchApplications(this.query)
                .then(({data}) => {
                    this.applications = data.data;
                    this.page = data.meta.page;
                    this.total = data.meta.total;
                }).finally(() => this.waiting = false)
        },

        isDisabled(application) {
            return this.currentApplications.some(app => app.uuid === application.uuid || application.mainType === TYPE_UNDEFINED);
        },

        fetchApplicationTypes() {
            this.waiting = true;
            return fetchApplicationTypes()
                .then(({data}) => {
                    this.types = data.data;
                }).finally(() => this.waiting = false)
        },

        grantAccess(application) {
            this.waiting = true;
            return grantAccessToApplication(application.uuid)
                .finally(() => {
                    this.waiting = false;
                    this.$emit('accessGranted', application);
                })
        }
    }

}
</script>

<style scoped>
    /deep/ .modal-content {
        min-height: 200px;
    }
</style>